import { render, staticRenderFns } from "./wf-login-form.vue?vue&type=template&id=0d3baf55&scoped=true"
import script from "./wf-login-form.vue?vue&type=script&lang=js"
export * from "./wf-login-form.vue?vue&type=script&lang=js"
import style0 from "./wf-login-form.vue?vue&type=style&index=0&id=0d3baf55&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3baf55",
  null
  
)

export default component.exports